export enum CountryLanguageCodes {
    deDE = 'de-DE',
    enDE = 'en-DE',
    frBE = 'fr-BE',
    nlBE = 'nl-BE',
    deAT = 'de-AT'
}
